module.exports = __webpack_public_path__ + "files/541589edbe33ea250b7246eafd314146.png";